module.exports = __webpack_public_path__ + "img/daikin-logo.3b583853.png";